import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  
  const [ user, setUser ] = useState(null);


  const [ ipInfo, setIpInfo ] = useState(null);
  const [ ipLocation, setIpLocation ] = useState(null);
  
  const UTIL_API_URL = "https://jqbbn3ao32.execute-api.us-west-1.amazonaws.com";
  // const AUTH_API_URL = "https://in7yqrn6y4.execute-api.us-west-1.amazonaws.com";
  const AUTH_API_URL = "https://khg7takfya.execute-api.us-west-1.amazonaws.com/users/registrar";

  const cookie_name = "posh-ems-user"

  const get = async (url, params) => {
    const headers = {
      'Content-Type': 'application/json',
    }        
    let data = null;
    await axios.get(url, {
      headers: headers,
      params: params,
    })
    .then( (response) => {
      // console.log('Response:', response.data);
      data = response.data;
    })
    .catch ( (error) => {
      // console.error('Error:', error);
			data = error.response.data;
    })
    .finally( () => {
    })
    return data;
  }

  const post = async (url, body=null) => {
    const headers = {
      'Content-Type': 'application/json',
    }        
    let data = null;

    await axios.post(url, body, {
      headers: headers,
    })
    .then( (response) => {
      // console.log('Response:', response.data);
      data = response.data;
    })
    .catch ( (error) => {
      // console.error('Error:', error);
			data = error.response.data;
    })
    .finally( () => {
    })
    return data;
  }

  const fetchIpInfo = async () => {
    // console.log("Start fetching IP info...");
    const url = UTIL_API_URL + '/check_ip_location';
        
    // const headers = {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Bearer ${user.credentials.AccessToken}`,
    // }        
    // await axios.get(url, {
    //   headers: headers,
    // })
    // .then( (response) => {
    //   if (response.data.data.ip_info) {
    //     setIpInfo(response.data.data.ip_info)
    //     if (response.data.data.ip_info.loc)
    //     {
    //       const loc = response.data.data.ip_info.loc;
    //       const lat = parseFloat(loc.split(",")[0]);
    //       const lng = parseFloat(loc.split(",")[1]);
    //       const location = {lat, lng}
    //       // console.log('IP location:', loc, location);
    //       // setIpLocation(location);
    //     }
    //   }
    // })
    // .catch ( (error) => {
    //   console.error('Error:', error);
    // })
    // .finally( () => {
    // })

    // const params = {
    //   user_id: user.email,
    // };

		const params = {}

    const response = await get(url, params);
    if (response)
    {
			if (response.data.data.ip_info) {
        setIpInfo(response.data.data.ip_info)
        if (response.data.data.ip_info.loc)
        {
          const loc = response.data.data.ip_info.loc;
          const lat = parseFloat(loc.split(",")[0]);
          const lng = parseFloat(loc.split(",")[1]);
          // const location = {lat, lng}
          // console.log('IP location:', loc, location);
          // setIpLocation(location);
        }
      }
    }
  }


	const login = async (email, password) => {

    const url = AUTH_API_URL + "/declare";

		const body = {
      "scope": "login",
      "email": email,
      "password": password,
    }

    const response = await post(url, body);
		return response;
  };


  const verifyLogin = async (email, code) => {
		
		const url = AUTH_API_URL + "/verify";

		const body = {
      "scope": "login",
      "email": email,
      "code": code,
    }

    const response = await post(url, body);
		console.log("Response:", response);

		if (response.code !== null && response.code == 0)
		{
			console.log("Code good");
			if (response.data && response.data.credentials)
			{
				const credentials = response.data.credentials;
				const profile = response.data.profile;
				setUser({email, credentials, profile});
				saveUser({email, credentials, profile});
			}
		}

		return response;
  };

	const signup = async (email, password) => {
		const url = AUTH_API_URL + "/declare";

		const body = {
      "scope": "registration",
      "email": email,
      "password": password,
    }

    const response = await post(url, body);
		console.log(response);
		return response;
  };

  async function verifySignup(email, code) 
	{
		const url = AUTH_API_URL + "/verify";

		const body = {
      "scope": "registration",
      "email": email,
      "code": code,
    }
	
    const response = await post(url, body);
		console.log("Response:", response);

		if (response.code !== null && response.code == 0)
		{
			console.log("Code good");
			if (response.data && response.data.credentials)
			{
				const credentials = response.data.credentials;
				const profile = response.data.profile;
				setUser({email, credentials, profile});
				saveUser({email, credentials, profile});
			}
		}

	}


	const resetPassword = async (email, password) => {
		const url = AUTH_API_URL + "/declare";

		const body = {
      "scope": "password_reset",
      "email": email,
      "new_password": password,
    }

    const response = await post(url, body);
		return response;
  };

	const verifyResetPassword = async (email, code) => {
		const url = AUTH_API_URL + "/verify";

		const body = {
      "scope": "password_reset",
      "email": email,
      "code": code,
    }

    const response = await post(url, body);

		// Unlike login, reset success comes back as code 200 with the tokens under data.credential (singular)
		if (response && response.data && response.data.credential)
		{
			const credentials = response.data.credential;
			const profile = response.data.profile;
			setUser({email, credentials, profile});
			saveUser({email, credentials, profile});
			return { ...response, signedIn: true };
		}

		return response;
  };


	const logout = async () => {
    console.log("Logging out");

    const data = {
      "scope": "logout",
      "email": user.email
    }

    const url = AUTH_API_URL + "/declare";

    await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then( (response) => {

    })
    .catch( (error) => {
    });

    forgetUser();
    setUser(null);

  };


  const checkAuth = (error) => {
		if (error && error.response && error.response.status) {
      console.log(error.response.status);
      console.log(error.response);
      if (error.response.status === 401)
      {
        logout(); 
      }
    }
	}


  const saveUser = ( _user ) => {
    // expires in 7 days
    Cookies.set(cookie_name, JSON.stringify(_user), { expires: 7 }); 
  };

  const loadUser = () => {
    // console.log("Loading user");

    const cookie_user = Cookies.get(cookie_name);
    const _user = cookie_user ? JSON.parse(cookie_user) : null;
    // console.log("Loaded user", _user);

    return _user ? _user : null;
  };

  const forgetUser = () => {
    Cookies.remove(cookie_name);
  };

  useEffect(() => {
    const _user = loadUser();
    setUser(_user);
  }, []);

  return (
    <AuthContext.Provider 
      value={{ 
        user, 
        login, verifyLogin, 
				signup, verifySignup, 
				resetPassword, verifyResetPassword,
				logout, 
        checkAuth,
        fetchIpInfo,
        ipInfo,
        ipLocation,
      }}
    >
      {children}
    </AuthContext.Provider>
  );

};


export const useAuth = () => useContext(AuthContext);